<template>
  <div>
    <div ref="mountEl"></div>
  </div>
</template>
<script src="./youtube-player.js"></script>
